import { useCallback, useEffect, useState } from 'react';
import { moldOrderService } from '../services/api';
import { ApprovalOrder, AssignedOrder } from '../types/mold';

export function useMyTasks() {
    const [tasks, setTasks] = useState<AssignedOrder[]>([]);
    const [approvalTasks, setApprovalTasks] = useState<ApprovalOrder[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<any>(null);

    const fetchTasks = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const response = await moldOrderService.getMyTasks();
            const myTasks = response.data.myWorks;
            setTasks(myTasks.assignedOrders as AssignedOrder[] || []);
            setApprovalTasks(myTasks.approvalOrders as ApprovalOrder[] || []);
        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchTasks();
    }, [fetchTasks]);

    return { tasks, approvalTasks, loading, error, refresh: fetchTasks } as const;
}
